import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { Col, Row } from 'react-flexbox-grid';
import { currencyFormatter } from '../../../common/utils/helpers';

const AccountStatistic = ({ t, receivedSum, investedSum, investingSum, profit, isLoadingInvestedAmount }) => (
  <section className={"text-center"}>
    <h2>{t('Štatistika účtu')}</h2>
    <Row center="xs">
      <Col xs={12} sm={12}>
        <h4>
          {t('Prijatá suma')}: {receivedSum === null ? '-' : currencyFormatter(receivedSum)}
        </h4>
        <h4>
          {t('Investovaná suma')}: {isLoadingInvestedAmount || investedSum === null ? '-' : currencyFormatter(investedSum)}
        </h4>
        <h4>
          {t('Suma na investovanie')}: {investingSum === null ? '-' : currencyFormatter(investingSum)}
        </h4>
        <br></br>
        <h4>
          {t('Zisk z investícií')}: {profit === null ? '-' : currencyFormatter((profit >= 0) ? profit : 0)}
        </h4>
      </Col>
    </Row>
  </section>
);

AccountStatistic.propTypes = {
  t: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
});

export default translate()(connect(mapStateToProps)(AccountStatistic));



// WEBPACK FOOTER //
// ./src/features/allocations/components/AccountStatistic.js